import { GET, POST } from "../fetch";
const root = "camping-manager";

export default {
    createCamping: async (camping, token) => {
        try {
            let response = await POST(
                `/${root}/create-camping`,
                camping,
                token
            );
            return response;
        } catch (error) {
            throw new Error(error);
        }
    },
    totalCamping: async (token) => {
        try {
            let response = await GET(`/${root}/total-camping`, token);
            return response;
        } catch (error) {
            throw new Error(error);
        }
    },
    campingWithRange: async (skip, limit, token) => {
        let body = { skip, limit };
        try {
            let response = await POST(
                `/${root}/camping-with-range`,
                body,
                token
            );
            return response;
        } catch (error) {
            throw new Error(error);
        }
    },
    searchCamping: async (searchText, token) => {
        try {
            let response = await GET(
                `/${root}/search-camping/${searchText}`,
                token
            );
            return response;
        } catch (error) {
            throw new Error(error);
        }
    },
};
